import { render } from "./ConfidenceHistogram.vue?vue&type=template&id=d708b886&scoped=true"
import script from "./ConfidenceHistogram.vue?vue&type=script&lang=js"
export * from "./ConfidenceHistogram.vue?vue&type=script&lang=js"

import "./ConfidenceHistogram.vue?vue&type=style&index=0&id=d708b886&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d708b886"]])

export default __exports__